import externalAPI from "./ExternalAPI";

// Function which will use to get connection feedback details
export const getConnFeedbackDetails = async (connData, type, options = {}) => {
  try {
    const data = [
      {
        agencyID: connData?.agencyID,
        connID: connData?.connID,
        type,
      }
    ];
    
    const result = await externalAPI.getData(2, "get", data, options);
    return result;
  } catch (error) {
    console.error(`Contact get details API error:`, error);
    throw error;
  }
}

// Function which will manage feedback set API
export const manageFeedbackSetAPI = async (fdbkData) => {
  try {
    fdbkData = [{
      ...fdbkData,
      type: 'FDBK',
    }]
    const result = await externalAPI.sendChange(2, 'set', fdbkData);
    return result;
  } catch (error) {
    console.error(`Feedback set API error:`, error);
    throw error;
  }
};